import React from 'react'
import CreatorComponent from '../common/Creator/CreatorComponent'
import {
    COLOR_KEYS,
    CreatorSettingColorType,
} from '../../hook/creator/useCreatorSettingColor'
import { getBackgroundCss } from '../../utils/creatorUtil'
import { CreatorBackgroundType, CreatorType } from '../../type/CreatorType'
import {
    CREATOR_PREVIEW_IMG_KEYS,
    PreviewImagesState,
} from '../../hook/creator/useCreatorSettingPreviewImg'

type Props = {
    creator?: CreatorType
    settingColor?: CreatorSettingColorType
    previewImages?: PreviewImagesState
    backgroundType?: CreatorBackgroundType
}

function NotFoundPage(props: Props): JSX.Element {
    const { creator, settingColor, previewImages, backgroundType } = props

    const customStyles =
        creator && settingColor && backgroundType && previewImages
            ? {
                  color: `${
                      settingColor[COLOR_KEYS.COLOR_TEXT_GENERAL_KEY].hex
                  }`,
                  background: getBackgroundCss(
                      backgroundType,
                      settingColor?.[COLOR_KEYS.COLOR_BACKGROUND_PAGE_KEY]?.hex,
                      previewImages[
                          CREATOR_PREVIEW_IMG_KEYS.BACKGROUND_PREVIEW_KEY
                      ]?.metaData?.url ?? creator?.backgroundImage?.url
                  ),
              }
            : {}

    return (
        <CreatorComponent>
            <section
                className="pt-20"
                style={{
                    height: '100vh',
                }}
            >
                <div
                    className="p-20"
                    style={{
                        ...customStyles,
                        borderRadius: '8px',
                        boxShadow: `rgba(0, 0, 0, 0.1) 0 0 15px`,
                    }}
                >
                    このページは存在しません
                </div>
            </section>
        </CreatorComponent>
    )
}

NotFoundPage.defaultProps = {
    creator: undefined,
    settingColor: undefined,
    previewImages: undefined,
    backgroundType: undefined,
}

export default NotFoundPage
